import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { handleActions } from 'redux-actions';
import { addToGroupFolderSuccess, addToGroupFolderFail, addToGroupFolder } from './actions';
import { getGroupFolderKey } from './helpers';
import { reduxKey } from './constants';
const actionHandlers = handleActions({
    [addToGroupFolder.toString()]: (state, { payload: { deviation: { deviationId }, groupFolderId } })=>_object_spread_props(_object_spread({}, state), {
            [getGroupFolderKey(deviationId, groupFolderId)]: {
                loading: true,
                added: false,
                suggested: false
            }
        }),
    [addToGroupFolderSuccess.toString()]: (state, { payload: { deviationId, groupFolderId, suggested } })=>_object_spread_props(_object_spread({}, state), {
            [getGroupFolderKey(deviationId, groupFolderId)]: {
                loading: false,
                added: !suggested,
                suggested
            }
        }),
    [addToGroupFolderFail.toString()]: (state, { payload: { deviationId, groupFolderId } })=>_object_spread_props(_object_spread({}, state), {
            [getGroupFolderKey(deviationId, groupFolderId)]: {
                loading: false,
                added: false,
                suggested: false
            }
        })
}, {});
export default {
    [reduxKey]: actionHandlers
};
